export default function Filter(props) {
  const label = props.label || "Filter";
  const value = props.value;
  const onChange = props.onChange;
  const options = props.options;

  // Callers can pass className to override the default width.
  // The default 130 px is fine for short labels (e.g. "All", "DDS Only") but too
  // narrow for longer labels like "Dental Assistant L1 Only".
  const className = props.className || "w-full sm:w-[130px]";

  return (
    <div className={className}>
      <label className="block text-xs font-semibold text-palette-slate-badge mb-1">{label}</label>

      <select
        className="w-full rounded-lg border border-palette-gray-divider bg-white px-3 py-2 text-sm"
        value={value}
        onChange={onChange}
      >
        {Array.isArray(options) &&
          options.map(function (opt) {
            return (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            );
          })}
      </select>
    </div>
  );
}
